import React from "react"
import Box from "components/Box"
import { GalleryModalContainer, GalleryModalFigcaption, GalleryModalFigure, GalleryModalImage } from "./styles"
import { AnimatePresence, motion } from "framer-motion"

const GalleryModal = ({ modal, closeModal }) => {
    return (
        <AnimatePresence>
            {modal && (
                <motion.div
                    initial={{ x: "100%" }}
                    animate={{ x: 0 }}
                    transition={{ ease: [0.16, 1, 0.3, 1], duration: 0.6 }}
                    exit={{ x: "110%" }}
                >
                    <GalleryModalContainer>
                        <svg
                            onClick={closeModal}
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            version="1.1"
                            viewBox="0 0 40 40"
                            style={{
                                position: "absolute",
                                right: 10,
                                top: "4%",
                                left: "2%",
                                cursor: "pointer"
                            }}
                        >
                            <path
                                fill="#df4a32"
                                d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z"
                            ></path>
                            <path
                                fill="#fff"
                                fillOpacity="0"
                                stroke="#372b2b"
                                strokeLinecap="round"
                                strokeMiterlimit="20"
                                strokeWidth="2"
                                d="M25 16l-9 9 M16 16l9 9"
                            ></path>
                        </svg>
                        <Box
                            width="100%"
                            height="100%"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            {(modal?.Image || modal?.image) && (
                                <GalleryModalFigure>
                                    <GalleryModalImage src={modal?.Image?.url || modal?.image?.url} alt="" />
                                    <GalleryModalFigcaption>{modal?.Image?.caption || modal?.image?.caption}</GalleryModalFigcaption>
                                </GalleryModalFigure>
                            )}
                        </Box>
                    </GalleryModalContainer>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default GalleryModal
